import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_MAP_SHOW_VEHICLE } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

/**
 * Main Map Route
 *
 * Primary map interface showing vehicle locations with real-time updates
 * Includes Navigator sidebar and requires map viewing permissions
 */
export const Route = createFileRoute('/_authenticated/maps')({
  beforeLoad: async ({ context }) => {
    // The map is the default post-login destination. Users without map access must return to the
    // landing route, which resolves the first available destination from their server-driven menu.
    await requirePermission(PERMISSION_MAP_SHOW_VEHICLE, ['read'], '/', context);

    // Return merged context with documentTitle
    // IMPORTANT: Spread parent context to preserve selectedCustomers
    return {
      ...context,
      isNavigatorEnabled: true,
      documentTitle: {
        main: 'menu.map',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: MapsRoute,
});

function MapsRoute() {
  // The map is mounted persistently by AppShell so changing routes does not recreate it.
  return null;
}
